/**
 * The original input panel's english translations
 */
export const GENERATED_INPUT_PANEL_EN = {
  generatedInput: 'Draft',
  generatedPlaceholder: 'Your generated Text',
  generatedPlaceholderTitle: 'Your generated Title',
  cancelGeneration: 'Stop Generation'
}

/**
 * The original input panel's german translations
 */
export const GENERATED_INPUT_PANEL_DE = {
  generatedInput: 'Entwurf',
  generatedPlaceholder: 'Ihr generierter Text',
  generatedPlaceholderTitle: 'Ihr generierter Title',
  cancelGeneration: 'Generierung stoppen'
}
